export default __webpack_public_path__ + "/assets/fonts/inter-latin-wght-normal.woff2";